const FooterFooter = () => {
    return (
        <h5 className="mainCopyright">Copyright &copy; 2023 UnitHQ, UnitVerse by chepel.com</h5>
    );
}

export default FooterFooter;